<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <footer class="footer">
      <div class="social-links">
        <a href="https://api.whatsapp.com/send?phone=393389448197"  target="_blank" class="social-link"><i class="fab fa-whatsapp"></i></a>
        <a href="https://www.instagram.com/sapori_miei" target="_blank" class="social-link"><i class="fab fa-instagram"></i></a>
        <a href="https://www.facebook.com/SaporiMieiVairanoPatenora"  target="_blank" class="social-link"><i class="fab fa-facebook"></i></a>
      </div>
      <div class="additional-info">
        <p>&copy; 2024 Sapori Miei. All rights reserved.</p>
        <p>Indirizzo: Strada Stradale Venafrana, Km.2.400, 81058, <span @click="handleLoginPage">Vairano Patenora</span></p>
      </div>
    </footer>
  </template>
  
  <script>
  import '@fortawesome/fontawesome-free/css/all.css';
  export default {
    methods:{
      handleLoginPage(){
        this.$router.push('/admin')
      }
    }
  };
  </script>
  
  <style scoped>
  .footer {
    background-color: var(--header-color);
    color: var(--text-color);
    padding: 20px;
    text-align: center;
  }
  
  .social-links {
    margin-bottom: 20px;
  }
  
  .social-link {
    color: var(--accent-color);
    font-size: 30px;
    margin: 12%;
    text-decoration: none;
  }
  
  .additional-info {
    font-size: 16px;
  }
  
  .additional-info p {
    margin: 5px 0;
  }
  </style>
  
  